/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "IdvStatus": {
                    "values": {
                      "SUSPENDED": 1,
                      "UNVERIFIED": 2,
                      "VERIFIED": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * --
 * Possible identity verification statuses simplified for SHOP use case.
 * Should match IDV_STATUS in app/lib/solidshop/idv/constants.rb
 * --
 *
 * SOURCE IdvStatus @ squareup/solidshop/v2/resources/idv.proto at 12:1
 */
export const IdvStatus = $root.lookupEnum('squareup.solidshop.v2.resources.IdvStatus').values;
